import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Row, Col, Spinner } from "react-bootstrap";
import { Edit, Trash } from "iconsax-react";

import { commentApi } from "../../../../utility/api/apiList";

import useAxios from "../../../../hooks/useAxios";
import convertDateToString from "../../../../libs/convertDateToString";

import ButtonComponent from "../../../public/button";
import InputComponent from "../../../public/form/input";

import {
  CommentContainer,
  CommentDetail,
  CommentHeaderBadge,
  CommentHeaderContainer,
  CommentDate,
} from "./styledUserCommentComponent";

function UserCommentComponent({ comment, handleDelete, runGetComments }) {
  const [isEditMode, setIsEditMode] = useState(false);

  const schema = yup.object().shape({
    title: yup.string().required("پر بودن این فیلد الزامی است."),
    content: yup.string().required("پر بودن این فیلد الزامی است."),
  });

  const {
    error: commentEditError,
    isLoading: commentEditLoading,
    run: commentEditRun,
  } = useAxios({
    url: `${commentApi}${comment.id}/`,
    method: "put",
    showSuccess: true,
    successMessage: "نظر با موفقیت تغییر کرد.",
  });

  const { register, handleSubmit, setValue } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    setValue("title", comment.title);
    setValue("content", comment.content);
  }, []);

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const submitEdit = (e) => {
    commentEditRun({ ...e, sim: comment.sim }).then(() => {
      setIsEditMode(false);
      runGetComments();
    });
  };

  return (
    <CommentContainer forwardedAs="article" className="w-100 p-3 mb-3">
      <Row className="mx-auto">
        <figure className="col-12 col-lg-3 d-flex flex-lg-column m-0 px-0">
          <img
            src={comment?.sim_pic}
            alt="آزمایش"
            width="140"
            height="70"
            className="ms-2 img-fluid"
          />
          <figcaption className="mt-2">{comment?.sim_name}</figcaption>
        </figure>
        <Col xs="12" lg="9">
          <Row>
            <Col xs="12" className="text-break px-1 mt-1">
              <CommentDetail isEditeMode={isEditMode} className="mb-2">
                {!isEditMode ? (
                  <>
                    <strong className="title">{comment?.title}</strong>
                    <p className="text text-dark">{comment?.content}</p>
                  </>
                ) : (
                  <form
                    onSubmit={handleSubmit(submitEdit)}
                    autoComplete={"off"}
                  >
                    <InputComponent
                      disabled={!isEditMode}
                      register={register("title")}
                      defaultValue={comment?.title}
                      autoComplete="off"
                      className="title text-dark"
                      maxLength={
                        process.env.REACT_APP_USER_COMMENT_TITLE_MAX_LENGTH
                      }
                    />
                    <InputComponent
                      as="textarea"
                      type="text"
                      disabled={!isEditMode}
                      register={register("content")}
                      defaultValue={comment?.content}
                      autoComplete="off"
                      containerClass="text text-dark"
                      maxLength={
                        process.env.REACT_APP_USER_COMMENT_CONTENT_MAX_LENGTH
                      }
                    />
                    <div className="d-flex justify-content-end mt-3">
                      <ButtonComponent type="submit">
                        {commentEditLoading ? (
                          <Spinner
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                            size="sm"
                          />
                        ) : (
                          "ثبت تغییر"
                        )}
                      </ButtonComponent>
                    </div>
                  </form>
                )}
              </CommentDetail>
            </Col>
            <Col xs="8" sm="9">
              <CommentHeaderContainer className="d-grid">
                <CommentHeaderBadge className="order-last order-lg-first">
                  {comment?.is_verified ? "تایید شده" : "در انتظار تایید"}
                </CommentHeaderBadge>
                <Edit size={18} onClick={toggleEditMode} />
                <Trash
                  size={20}
                  className="order-first order-lg-last"
                  onClick={() => handleDelete(comment?.id)}
                />
              </CommentHeaderContainer>
            </Col>
            <CommentDate className="col-4 col-sm-3">
              {convertDateToString("fullNumber", comment?.datetime)}
            </CommentDate>
          </Row>
        </Col>
      </Row>
    </CommentContainer>
  );
}

export default UserCommentComponent;
